import { mount } from 'svelte';
import App from './App.svelte';
import './css/style.css';

/**
 * Eruda — console mobile embarquée. Lazy-loaded via dynamic import, donc
 * ne pèse rien dans le bundle principal en production.
 *
 * Activation :
 *   - `?debug=1` dans l'URL → active + persiste via localStorage
 *   - `?debug=0` → désactive + retire
 *   - Sinon : utilise la dernière valeur en localStorage
 *
 * À utiliser sur iPhone (ou tout mobile sans accès aux DevTools natifs)
 * pour diagnostiquer les erreurs JS, voir les requêtes réseau, inspecter
 * le DOM. Génère un bouton flottant en bas-droite qui ouvre un panel.
 */
function maybeBootEruda(): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const debugParam = params.get('debug');
  if (debugParam === '1') {
    try {
      localStorage.setItem('perleur.debug', '1');
    } catch {
      /* localStorage indispo : on continue, Eruda actif pour la session */
    }
  } else if (debugParam === '0') {
    try {
      localStorage.removeItem('perleur.debug');
    } catch {
      /* idem */
    }
    return; // pas d'init
  }
  let enabled = debugParam === '1';
  if (!enabled) {
    try {
      enabled = localStorage.getItem('perleur.debug') === '1';
    } catch {
      enabled = false;
    }
  }
  if (!enabled) return;
  // Dynamic import : chunk séparé, pas dans le bundle main en prod.
  void import('eruda').then((mod) => {
    mod.default.init();
  });
}

maybeBootEruda();

const target = document.getElementById('app');
if (!target) {
  throw new Error('Élément racine #app introuvable dans index.html');
}

export default mount(App, { target });
